<template>
  <Publication :publication="last_publication.data" />
</template>
<script>
import { reactive } from "vue";
import Publication from "../common/Publication/Publication.vue";

export default {
  components: {
    Publication,
  },
  async setup() {
    const last_publication = reactive({ data: {} });

    const query = `query{
      communityById(id: "2b5830db-dd78-4290-85de-f27dd05c76c0"){
        id
        name
        items(
          first: 1
          page: 1
          orderBy: { column: ACCESIONED_DATE, order: DESC }
        ){
          data{
            id
            handle
            issued_date
            thumbnail
            url
            metadata(orderBy:{ column: METADATA_FIELD_ID, order: ASC }){
              metadata_field_id
              value
              element
              qualifier
            }
          }
        }
      }
    }`;

    await fetch("https://repositorio.igp.gob.pe/REGEN_api/public/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ query }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.data?.communityById?.items?.data?.length > 0) {
          const item = result.data.communityById.items.data[0];

          // Adaptar estructura de datos para que sea compatible con el componente Publication
          last_publication.data = {
            handle: item.handle,
            name:
              item.metadata.find((m) => m.element === "title" && !m.qualifier)
                ?.value || "",
            bitstreams: [
              {
                bundleName: "THUMBNAIL",
                retrieveLink: item.thumbnail,
              },
            ],
            metadata: item.metadata.map((m) => ({
              key: m.qualifier
                ? `dc.${m.element}.${m.qualifier}`
                : `dc.${m.element}`,
              value: m.value,
            })),
          };
        }
      })
      .catch((error) => {
        console.error("Error fetching publication:", error);
      });

    return {
      last_publication,
    };
  },
};
</script>
<style lang="scss"></style>
